<template>
  <v-row>
    <v-col cols='12' :class='backgroundClass'>
      <br>
      <span :class='titleClass'>
        {{ title }}
      </span>
      <br v-if="$vuetify.breakpoint.smAndDown">
      <span :class='subtitleClass'>{{ subtitle }}</span>
      <v-divider v-if='!hideLine'></v-divider>
    </v-col>
  </v-row>
</template>

<script>

export default {
  name: 'section-title',
  props: {
    title: {
      required: false,
      default: ''
    },
    subtitle: {
      required: false,
      default: ''
    },
    hideLine: {
      required: false,
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    titleClass: 'headline grey--text text-uppercase font-weight-light',
    subtitleClass: 'display-1 grey--text text-uppercase font-weight-light',
    backgroundClass: 'my-5 py-5'
  })
}
</script>
